import { baseUrl } from "./env";
import { Message } from "element-ui";
import store from "../store";
import router from "../router/index";

export default async (
  url = "",
  data = {},
  type = "GET",
  update = false,
  isDownload
) => {
  if (url.includes("UserHeartBeat") || url.includes("ProductUserHeartBeat")) {
    store.commit("setGlobalLoading", false);
  } else {
    store.commit("setGlobalLoading", true);
  }
  let checkType = (response, reject) => {
    if (response.status == 404) {
      if (lang == "en") {
        Message({
          type: "warning",
          showClose: true,
          message: response.statusText || "not found",
        });
      } else {
        Message({
          type: "warning",
          showClose: true,
          message:
            "服务器找不到您所请求的文件或脚本。请检查URL 以确保路径正确。如果问题依然存在，请与服务器的管理员联系。",
        });
      }
      reject();
    }
    if (response.status == 500) {
      let message = lang == "zh" ? "内部服务器错误" : "Internal Server Error";
      const result = url.includes('SaveDataManagerDBData') ? response.json() : null
      return {
        isSuccess: false,
        status: 500,
        message: message,
        result
      };
    }
    if (response.status == 401) {
      router.push({ name: "401" });
      return;
    }

    if (response.status == 403) {
      if (lang == "en") {
        Message({
          type: "warning",
          showClose: true,
          message: "You do not have access",
        });
      } else {
        Message({
          type: "warning",
          showClose: true,
          message: "您没有访问权限",
        });
      }
      reject();
    }

    if (response.status == 413) {
      reject();
    }
  };
  type = type.toUpperCase();

  url = baseUrl + url;
  let lang = store.getters.getLanguage,
    Authorization = "";

  if (type == "GET" || type == "DELETE") {
    let dataStr = ""; //数据拼接字符串
    Object.keys(data).forEach((key) => {
      dataStr += key + "=" + data[key] + "&";
    });

    if (dataStr !== "") {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      url = url + "?" + dataStr;
    }

    if (url.indexOf("?") < 0) url += "?r=" + Math.random();
    else url += "&r=" + Math.random(); //IE对API有缓存，要加随机参数
  }
  if (url.includes("CheckToken")) {
    Authorization = data.token;
  } else if (store.state.clientToken) {
    Authorization = localStorage.clientToken || store.state.clientToken;
  }

  let requestConfig = {
    credentials: "include",
    method: type,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
    mode: "cors",
    cache: "force-cache",
  };
  if (isDownload) {
    requestConfig.responseType = "blob";
  }
  if (store.state.language || lang) {
    requestConfig.headers.lang = store.state.language || lang;
  }
  if (Authorization) {
    requestConfig.headers.Authorization = Authorization;
  }

  if (store.state.systemConfig && store.state.systemConfig.angleOfView == 2) {
    if (store.state.clientGlobalRole || localStorage.clientGlobalRole) {
      requestConfig.headers.roleid =
        store.state.clientGlobalRole || localStorage.clientGlobalRole;
    }
  }
  if (type == "POST" || type == "PUT") {
    if (update) {
      Object.defineProperty(requestConfig, "body", {
        value: data,
      });
    } else {
      requestConfig.headers["Content-Type"] = "application/json;charset=UTF-8";
      Object.defineProperty(requestConfig, "body", {
        value: JSON.stringify(data),
      });
    }
  }
  return new Promise((resolve, reject) => {
    fetch(url, requestConfig)
      .then((response) => {
        if (isDownload) {
          const disposition = response.headers.get("content-disposition");
          if (disposition) {
            const fileName = window.decodeURI(
              response.headers
                .get("content-disposition")
                .split(";")[2]
                .split("=")[1]
                .split("''")[1],
              "UTF-8"
            );
            if (fileName) {
              response.blob().then((res) => {
                require("downloadjs")(new Blob([res]), fileName);
              });
            }
            return {
              fileName: fileName,
            };
          } else {
            return response.json();
          }
        }
        if (response.status == 406 && url.includes("Login")) {
          return response.json();
        }
        if (response.ok) {
          return response.json();
        } else {
          store.commit("setGlobalLoading", false);
          return checkType(response, reject);
        }
      })
      .then(async (response) => {
        if (response) {
          if (
            !url.includes("UserHeartBeat") &&
            !url.includes("ProductUserHeartBeat")
          ) {
            store.commit("setGlobalLoading", false);
          }
          if (!response.isSuccess && !url.includes("CheckLicenseState") && !response.result && (response.message || response.Message)) {
            console.log(response.message)
            Message({
              type: "warning",
              showClose: true,
              message: response.message || response.Message,
              dangerouslyUseHTMLString: true,
              duration: 10000,
            });
          }
          let errMessage = null
          if (response.result) {
            await (response.result).then((errMsg) => {
              errMessage = errMsg.messages[0] || errMsg.Message
            })
          }
          response.errMessage = errMessage;
          resolve(response);
        } else {
          reject(false);
        }
      })
      .catch((err) => {
        if (
          !url.includes("UserHeartBeat") &&
          !url.includes("ProductUserHeartBeat")
        ) {
          store.commit("setGlobalLoading", false);
        }
        reject(err);
      });
  }).catch((err) => {
    console.log(err, "请求出错，地址:" + url);
  });
};
